import { type FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { useFilter } from "@/partner/shared/components/Filter";
import { SimpleTableCard } from "@/partner/shared/components/SimpleTableCard";
import { formatNumber } from "@/shared/utils/formatNumber";
import { useAnalyticsUsersByUtmQuery } from "@/partner/entities/analytics";
import type { UtmDimensionValue } from "./AnalyticsViewsByUtmTable";
import { DownloadReportButton } from "@/partner/features/reports";
import {
  AnalyticsWidgetType,
  ReportTypeType,
} from "@/types/graphql/partner.generated";

interface AnalyticsUsersByUtmTableProps {
  dimension: UtmDimensionValue;
  title: string;
}

export const AnalyticsUsersByUtmTable: FC<AnalyticsUsersByUtmTableProps> = ({
  dimension,
  title,
}) => {
  const { t } = useTranslation();
  const { filter } = useFilter();
  const [limit, setLimit] = useState(10);

  const { data, loading, error } = useAnalyticsUsersByUtmQuery({
    variables: { filter: filter as never, dimension: dimension as never },
  });

  const rows = (data?.analyticsUsers.usersByUtm ?? [])
    .slice(0, limit)
    .map((row) => [row.value, formatNumber(row.users)]);

  return (
    <SimpleTableCard
      title={title}
      columns={[
        { name: t("analytics.users.columnUtmValue") },
        { name: t("analytics.users.columnUsers") },
      ]}
      rows={rows}
      loading={loading}
      error={error}
      limit={limit}
      setLimit={setLimit}
      downloadButton={
        <DownloadReportButton
          variant="card"
          type={ReportTypeType.AnalyticsWidgetType}
          widget={AnalyticsWidgetType.UsersByUtmType}
          filter={filter}
          variables={{ dimension }}
        />
      }
    />
  );
};
